import { Container, Grid } from '@material-ui/core'
import React, { useState } from 'react'
import { Field, Form, FormElement } from '@progress/kendo-react-form'
import TextAreaWrapper from '../../onboarding/steps/inputs/textareaWrapper'
import InputPureWrapper from '../../onboarding/steps/inputs/inputPureWrapper'
import { ButtonHLPure } from '../../../pures'
import { requiredValidator } from '../components/validator'
import { useTranslation } from 'react-i18next'

const StartNodeDetails = (props) => {
    const { node, onSaveNode } = props
    const { t } = useTranslation('chatbot', { keyPrefix: 'conversationsConfig.conversations' })
    const { t: tCommon } = useTranslation('common')

    const [data, setData] = useState(node.data)
    const [formKey, setFormKey] = useState(1)
    const resetForm = () => setFormKey(formKey + 1)

    const onSubmit = async (formData) => {
        await onSaveNode(formData)
        setData(prev => ({ ...prev, ...formData }))
        resetForm()
    }

    return (
        <Container disableGutters>
            <Form
                key={`startNode-${formKey}`}
                initialValues={data}
                onSubmit={onSubmit}
                render={(formRenderProps) => {
                    return (
                        <FormElement>
                            <Grid container spacing={2} className='conversation-node-form user-node-form'>
                                <Grid item xs={12}>
                                    <h3>{t('startNode.title')}</h3>
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        id='name'
                                        name={'name'}
                                        component={InputPureWrapper}
                                        label={t('startNode.name')}
                                        validator={requiredValidator}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        id='description'
                                        name={'description'}
                                        component={TextAreaWrapper}
                                        label={t('userNode.description')}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        id='suggestedText'
                                        name={'suggestedText'}
                                        component={InputPureWrapper}
                                        label={t('userNode.suggestedText')}
                                        validator={requiredValidator}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        id='keyWords'
                                        name={'keyWords'}
                                        component={InputPureWrapper}
                                        label={t('userNode.keyWords')}
                                    />
                                </Grid>

                                <Grid item xs={12} className='button-actions'>
                                    {
                                        formRenderProps.modified &&
                                        <>
                                            <ButtonHLPure
                                                colorScheme='error'
                                                outlined
                                                nameBtn={tCommon('cancel')}
                                                onClick={resetForm}
                                                disabled={formRenderProps.submitted}
                                            />
                                            <ButtonHLPure
                                                primary
                                                nameBtn={tCommon('save')}
                                                type='submit'
                                                disabled={formRenderProps.submitted}
                                            />
                                        </>
                                    }
                                </Grid>
                            </Grid>
                        </FormElement>
                    )
                }}
            />
        </Container>
    )
}

export default StartNodeDetails